module.exports = __webpack_public_path__ + "img/construction_thumbnail-600x450.7ee7d076.jpg";